import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { WhatYouWillLearn } from '@/features/course-landing-page/components/what-you-will-learn/what-you-will-learn.react-component';
import { RelatedTopics } from '@/features/course-landing-page/components/related-topics/related-topics.react-component';
import { Description } from '@/features/course-landing-page/components/course-description/course-description.react-component';
import { CourseIncludes, CourseIncludesPlacement } from '../course-includes/course-includes.react-component';
import { Requirements } from '@/features/course-landing-page/components/course-requirements/course-requirements.react-component';
import { useClpPurchaseContext } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { Curriculum } from '@/features/course-landing-page/components/course-curriculum/curriculum.react-component';
import { CodingExercisePromotion } from '@/features/course-landing-page/components/coding-exercise-promotion/coding-exercise-promotion.react-component';
import { InstructorList } from '@/features/course-landing-page/components/instructor-module/instructor-list/instructor-list.react-component';
import { ReviewsContainer } from '@/features/course-landing-page/components/reviews/reviews-container.react-component';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { useCourseCareerAccelerator } from '@/features/course-landing-page/context/career-accelerator-provider.react-component';
import { MoreCoursesByInstructors } from '@/features/course-landing-page/components/more-courses-by-instructors/more-courses-by-instructors.react-component';
import { FrequentlyBoughtTogetherWithBundleUnit } from '@/features/course-landing-page/components/bundle-unit/frequently-bought-together/frequently-bought-together.react-component';
import { StudentsAlsoBoughtRecommendationsWrapper } from '../students-also-bought/students-also-bought-recommendations-wrapper.react-component';
import { CertificationVoucherBundleUnit, CourseCertificationUnit, GoogleCareerAcceleratorData, GoogleCareerCourseCarousel, IncentiveTextType } from '@udemy-v2/react-certification-preparation';
import { publishEvent, TrackImpression } from '@udemy-v2/event-tracking';
import { ExperimentImpressionEvent, useFeatures } from '@udemy-v2/react-experimentation';
import { GrowWithGoogleCertificateBanner } from '@udemy-v2/react-subscription-browse';
import { VernacularCohortBanner } from '@udemy-v2/react-globalization-components';
import { useMatchMedia } from '@udemy-v2/design-system-utils';
import { CertificationBundle } from '../bundle-unit/certification-bundle/certification-bundle.react-component';
import { tokens } from '@udemy-v2/styles';
import styles from './course-body-content.module.scss';
import { ReportAbuse } from '../report-abuse/report-abuse.react-component';
import { LocalizedHtml, useI18n } from '@udemy-v2/i18n';
import { getGoogleCareerPathUrl } from '@/features/course-landing-page/utils/google';
import { useClpVoucherContext } from '@/features/course-landing-page/context/voucher-context.react-component';
import { CourseSubscriptionAvailabilityStatus, useCoursesSubscriptionAvailabilityQuery } from '@/generated/graphql';
import { BUNDLE_COUPON } from '@/features/course-landing-page/constants';
import { CourseRetirementBanner } from '../course-retirement-banner/course-retirement-banner.react-component';
import { useUserHasOrganization } from '@/lib/hooks/use-user-has-organization';
export const CourseBodyContent = () => {
  const $ = _c(97);
  const {
    gettext,
    interpolate
  } = useI18n();
  const hasOrganization = useUserHasOrganization();
  const isMobile = useMatchMedia(`(max-width: ${tokens["viewport-sm-max"]})`);
  const isDesktop = useMatchMedia(`(min-width: ${tokens["viewport-lg-min"]})`);
  const course = useClpCourse();
  const {
    isLoading,
    isCourseInAvailablePlans,
    isPersonalPlanSubscriber,
    useCollapsiblePurchaseSection
  } = useClpPurchaseContext();
  const courseCareerAccelerator = useCourseCareerAccelerator();
  const isMarketplace = !isPersonalPlanSubscriber && !hasOrganization;
  const courseIncludedInAvailableSubscription = !isLoading && isCourseInAvailablePlans;
  const renderIncentivesInCourseBody = isMobile || !isMobile && courseIncludedInAvailableSubscription || useCollapsiblePurchaseSection;
  const {
    hydratedCertificationBundle,
    isLoading: isLoadingVoucherContext
  } = useClpVoucherContext();
  let t0;
  if ($[0] !== hydratedCertificationBundle?.contents) {
    t0 = hydratedCertificationBundle?.contents.map(_temp) ?? [];
    $[0] = hydratedCertificationBundle?.contents;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const courseIds = t0;
  const hasCertBundle = !!hydratedCertificationBundle && courseIds.length > 0;
  const courseIncludesCodingExercise = course.curriculum?.contentCounts?.codingExercisesCount && course.curriculum.contentCounts.codingExercisesCount > 0;
  const showUpdatedCertificationUnit = !hasOrganization;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["show_certification_voucher_bundle_unit"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    isLoading: isFeaturesLoading,
    featureVariantAssignments
  } = useFeatures(t1);
  const isGrowWithGoogleCourse = !!course.contentCollectionInfo?.isInGooglePartnerCollection;
  let t2;
  if ($[3] !== featureVariantAssignments) {
    t2 = featureVariantAssignments.get("show_certification_voucher_bundle_unit");
    $[3] = featureVariantAssignments;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const certificationVoucherBundleUnitFeature = t2;
  const showCertificationVoucherBundleUnit = certificationVoucherBundleUnitFeature?.configuration?.showCertificationVoucherBundleUnit;
  let t3;
  if ($[5] !== courseIds) {
    t3 = {
      ids: courseIds
    };
    $[5] = courseIds;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== hasCertBundle) {
    t4 = {
      enabled: hasCertBundle
    };
    $[7] = hasCertBundle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data: bundleSubscriptionData,
    isLoading: isBundleSubscriptionLoading
  } = useCoursesSubscriptionAvailabilityQuery(t3, t4);
  let t5;
  if ($[9] !== bundleSubscriptionData?.courses || $[10] !== isBundleSubscriptionLoading) {
    t5 = !isBundleSubscriptionLoading && (bundleSubscriptionData?.courses ?? []).every(_temp2);
    $[9] = bundleSubscriptionData?.courses;
    $[10] = isBundleSubscriptionLoading;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const allCoursesExcludedFromSubscription = t5;
  const canRenderCertificationVoucherBundleUnit = showCertificationVoucherBundleUnit && !!hydratedCertificationBundle && allCoursesExcludedFromSubscription;
  let t6;
  if ($[12] !== course.id) {
    t6 = {
      contextId: "clp-bundle" as const,
      sourceObjects: [{
        id: course.id,
        type: "COURSE" as never
      }]
    };
    $[12] = course.id;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const bundleContextInput = t6;
  const pathName = courseCareerAccelerator?.career?.name ?? "";
  let t7;
  if ($[14] !== courseCareerAccelerator || $[15] !== gettext || $[16] !== interpolate || $[17] !== pathName) {
    t7 = courseCareerAccelerator ? <LocalizedHtml html={interpolate(gettext("After completion of all courses in the <a class=\"certificate\">%(certificateName)s</a> path, earn a professional certificate that you can share on social media, LinkedIn, resume, or CV. "), {
      certificateName: pathName
    }, true)} interpolate={{
      certificate: <a href={getGoogleCareerPathUrl(courseCareerAccelerator.slug)}>{pathName}</a>
    }} /> : null;
    $[14] = courseCareerAccelerator;
    $[15] = gettext;
    $[16] = interpolate;
    $[17] = pathName;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const certificateBannerDescription = t7;
  let t8;
  if ($[19] !== hasOrganization) {
    t8 = hasOrganization && <CourseRetirementBanner />;
    $[19] = hasOrganization;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== certificateBannerDescription || $[22] !== courseCareerAccelerator || $[23] !== gettext) {
    t9 = courseCareerAccelerator && courseCareerAccelerator.certificateInfo?.certificateImageUrl && <GrowWithGoogleCertificateBanner iconButtonProps={{
      href: getGoogleCareerPathUrl(courseCareerAccelerator.slug)
    }} description={certificateBannerDescription} title={gettext("Earn a certificate from Google")} />;
    $[21] = certificateBannerDescription;
    $[22] = courseCareerAccelerator;
    $[23] = gettext;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const t10 = Number(course.id);
  let t11;
  if ($[25] !== isMarketplace || $[26] !== isMobile || $[27] !== showUpdatedCertificationUnit || $[28] !== t10) {
    t11 = <CourseCertificationUnit courseId={t10} linkToTopic={isMarketplace} showLearnMoreModal={isMarketplace} isMobile={isMobile} showAddToInterestButton={showUpdatedCertificationUnit} showIncentiveTextType={IncentiveTextType.PUBLIC} />;
    $[25] = isMarketplace;
    $[26] = isMobile;
    $[27] = showUpdatedCertificationUnit;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== course.learningOutcomes) {
    t12 = <WhatYouWillLearn objectives={course.learningOutcomes} />;
    $[30] = course.learningOutcomes;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== course) {
    t13 = <RelatedTopics course={course} />;
    $[32] = course;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== renderIncentivesInCourseBody) {
    t14 = renderIncentivesInCourseBody && <CourseIncludes placement={CourseIncludesPlacement.BODY} />;
    $[34] = renderIncentivesInCourseBody;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== course.frontendTrackingId || $[37] !== course.id || $[38] !== courseIncludesCodingExercise) {
    t15 = !!courseIncludesCodingExercise && <CodingExercisePromotion courseId={Number(course.id)} frontendTrackingId={course.frontendTrackingId || ""} />;
    $[36] = course.frontendTrackingId;
    $[37] = course.id;
    $[38] = courseIncludesCodingExercise;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Curriculum />;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== course.isPracticeTestCourse || $[42] !== course.prerequisites) {
    t17 = !course.isPracticeTestCourse && <Requirements prerequisites={course.prerequisites} />;
    $[41] = course.isPracticeTestCourse;
    $[42] = course.prerequisites;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== course.description || $[45] !== course.targetAudience) {
    t18 = <Description description={course.description} targetAudience={course.targetAudience} />;
    $[44] = course.description;
    $[45] = course.targetAudience;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== courseCareerAccelerator || $[48] !== gettext || $[49] !== isGrowWithGoogleCourse) {
    t19 = isGrowWithGoogleCourse && courseCareerAccelerator && <GoogleCareerCourseCarousel ariaLabel={gettext("Google Career Certificate courses")} acceleratorData={[courseCareerAccelerator] as GoogleCareerAcceleratorData[]} ctaHref={getGoogleCareerPathUrl(courseCareerAccelerator.slug)} />;
    $[47] = courseCareerAccelerator;
    $[48] = gettext;
    $[49] = isGrowWithGoogleCourse;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== certificationVoucherBundleUnitFeature || $[52] !== hydratedCertificationBundle || $[53] !== isFeaturesLoading) {
    t20 = !isFeaturesLoading && hydratedCertificationBundle && <TrackImpression trackFunc={() => {
      if (certificationVoucherBundleUnitFeature) {
        const {
          experimentIds: t21,
          isLocalDefault: t22
        } = certificationVoucherBundleUnitFeature;
        const experimentIds = t21 === undefined ? [] : t21;
        const isLocalDefault = t22 === undefined ? false : t22;
        publishEvent(new ExperimentImpressionEvent({
          experimentIds,
          isLocalDefaultShown: isLocalDefault
        }));
      }
    }} onlyOnce={true}><div /></TrackImpression>;
    $[51] = certificationVoucherBundleUnitFeature;
    $[52] = hydratedCertificationBundle;
    $[53] = isFeaturesLoading;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== canRenderCertificationVoucherBundleUnit || $[56] !== hydratedCertificationBundle || $[57] !== isFeaturesLoading) {
    t21 = !isFeaturesLoading && canRenderCertificationVoucherBundleUnit && hydratedCertificationBundle ? <CertificationVoucherBundleUnit layout="vertical" bundle={hydratedCertificationBundle} isVoucherBundleDiscountEnabled={true} bundleCouponCode={BUNDLE_COUPON} /> : null;
    $[55] = canRenderCertificationVoucherBundleUnit;
    $[56] = hydratedCertificationBundle;
    $[57] = isFeaturesLoading;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== isDesktop) {
    t22 = isDesktop && <VernacularCohortBanner context={{
      entryPoint: "course"
    }} />;
    $[59] = isDesktop;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <StudentsAlsoBoughtRecommendationsWrapper />;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== bundleContextInput || $[63] !== canRenderCertificationVoucherBundleUnit || $[64] !== courseIds || $[65] !== hasCertBundle || $[66] !== hasOrganization || $[67] !== isFeaturesLoading || $[68] !== isLoadingVoucherContext) {
    t24 = !isFeaturesLoading && !isLoadingVoucherContext ? <div className={styles["bundle-unit-container"]}>{canRenderCertificationVoucherBundleUnit ? null : hasCertBundle ? <CertificationBundle bundleCourseIds={courseIds} /> : hasOrganization ? null : <FrequentlyBoughtTogetherWithBundleUnit contextInput={bundleContextInput} />}</div> : null;
    $[62] = bundleContextInput;
    $[63] = canRenderCertificationVoucherBundleUnit;
    $[64] = courseIds;
    $[65] = hasCertBundle;
    $[66] = hasOrganization;
    $[67] = isFeaturesLoading;
    $[68] = isLoadingVoucherContext;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <InstructorList />;
    $[70] = t25;
  } else {
    t25 = $[70];
  }
  const t26 = parseInt(course.id, 10);
  let t27;
  if ($[71] !== t26) {
    t27 = <ReviewsContainer courseId={t26} />;
    $[71] = t26;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== course.instructors || $[74] !== hasOrganization) {
    t28 = !hasOrganization && <MoreCoursesByInstructors instructors={course.instructors} />;
    $[73] = course.instructors;
    $[74] = hasOrganization;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  let t29;
  if ($[76] !== course.id || $[77] !== hasOrganization) {
    t29 = !hasOrganization && <ReportAbuse objectId={Number(course.id)} objectType="course" fullWidthButton={true} udStyle="secondary" withDivider={true} />;
    $[76] = course.id;
    $[77] = hasOrganization;
    $[78] = t29;
  } else {
    t29 = $[78];
  }
  let t30;
  if ($[79] !== t11 || $[80] !== t12 || $[81] !== t13 || $[82] !== t14 || $[83] !== t15 || $[84] !== t17 || $[85] !== t18 || $[86] !== t19 || $[87] !== t20 || $[88] !== t21 || $[89] !== t22 || $[90] !== t24 || $[91] !== t27 || $[92] !== t28 || $[93] !== t29 || $[94] !== t8 || $[95] !== t9) {
    t30 = <div className={styles.container}>{t8}{t9}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t27}{t28}{t29}</div>;
    $[79] = t11;
    $[80] = t12;
    $[81] = t13;
    $[82] = t14;
    $[83] = t15;
    $[84] = t17;
    $[85] = t18;
    $[86] = t19;
    $[87] = t20;
    $[88] = t21;
    $[89] = t22;
    $[90] = t24;
    $[91] = t27;
    $[92] = t28;
    $[93] = t29;
    $[94] = t8;
    $[95] = t9;
    $[96] = t30;
  } else {
    t30 = $[96];
  }
  return t30;
};
function _temp(c) {
  return String(c.id);
}
function _temp2(course_0) {
  return course_0?.subscriptionInfo?.availabilityStatus === CourseSubscriptionAvailabilityStatus.None;
}